import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import GalleryHero from '../components/Gallery/GalleryHero';
import VideoGallery from '../components/Gallery/VideoGallery';
import PhotoGallery from '../components/Gallery/PhotoGallery';

const GalleryPage = () => {
  return (
    <>
      <Header />
      <main>
        <GalleryHero />
        {/* <FeaturedVideo /> */}
        <VideoGallery />
        <PhotoGallery />
      </main>
      <Footer />
    </>
  );
};

export default GalleryPage;
